export const getLoadingBarTpl = () => {
  return '<div class="loadingbar"></div>';
};

export const getSectionTpl = () => {
  return `
	  <section class="variation variation__stat">
			<dl class="stat-STR">
				<dt class="STR"> <!-- em1, em2, em3 -->
					<strong>STR</strong>
					<span class="util">
						{{? it.page === "default" || it.page === 'modify' }}<button class="down">-</button>{{?}}
						<var>{{=it.STR}}</var>
						{{? it.page === "default" || it.page === 'modify' }}<button class="up">+</button>{{?}}
					</span>
				</dt>
				<dd>
					<ul>
						<li class="DAMAGE_SHORT"><label>근거리 대미지</label><var>{{=it.DAMAGE_SHORT}}</var></li>
            <li class="HIT_SHORT"><label>근거리 명중</label><var>{{=it.HIT_SHORT}}</var></li>
            <li class="FATAL_SHORT"><label>근거리 치명타</label><var>{{=it.FATAL_SHORT}}</var></li>
            <li class="WEIGHT"><label>최대 소지 무게</label><var>{{=it.WEIGHT}}</var></li>
					</ul>
				</dd>
			</dl>

			<dl class="stat-DEX">
				<dt class="DEX">
					<strong>DEX</strong>
					<span class="util">
						{{? it.page === "default" || it.page === 'modify' }}<button class="down">-</button>{{?}}
						<var>{{=it.DEX}}</var>
						{{? it.page === "default" || it.page === 'modify' }}<button class="up">+</button>{{?}}
					</span>
				</dt>
				<dd>
					<ul>
						<li class="DAMAGE_LONG"><label>원거리 대미지</label><var>{{=it.DAMAGE_LONG}}</var></li>
            <li class="HIT_LONG"><label>원거리 명중</label><var>{{=it.HIT_LONG}}</var></li>
            <li class="FATAL_LONG"><label>원거리 치명타</label><var>{{=it.FATAL_LONG}}</var></li>
            <li class="AC"><label>물리 방어력(AC)</label><var>{{=it.AC}}</var></li>
            <li class="ER"><label>원거리 회피력(ER)</label><var>{{=it.ER}}</var></li>
					</ul>
				</dd>
			</dl>
			
			<dl class="stat-INT">
				<dt class="INT">
					<strong>INT</strong>
					<span class="util">
						{{? it.page === "default" || it.page === 'modify' }}<button class="down">-</button>{{?}}
						<var>{{=it.INT}}</var>
						{{? it.page === "default" || it.page === 'modify' }}<button class="up">+</button>{{?}}
					</span>
				</dt>
				<dd>
					<ul>
						<li class="DAMAGE_WIZ"><label>마법 대미지</label><var>{{=it.DAMAGE_WIZ}}</var></li>
            <li class="HIT_WIZ"><label>마법적중</label><var>{{=it.HIT_WIZ}}</var></li>
            <li class="FATAL_WIZ"><label>마법 치명타</label><var>{{=it.FATAL_WIZ}}</var></li>
            <li class="MB"><label>마법 보너스(MB)</label><var>{{=it.MB}}</var></li>
            <li class="MP_MINUS"><label>MP 소모 감소</label><var>{{=it.MP_MINUS}}</var></li>
					</ul>
				</dd>
			</dl>
			
			<dl class="stat-WIS">
				<dt class="WIS">
					<strong>WIS</strong>
					<span class="util">
						{{? it.page === "default" || it.page === 'modify' }}<button class="down">-</button>{{?}}
						<var>{{=it.WIS}}</var>
						{{? it.page === "default" || it.page === 'modify' }}<button class="up">+</button>{{?}}
					</span>
				</dt>
				<dd>
					<ul>
						<li class="LEVELUP_MP_PLUS"><label>레벨업시 MP 증가</label><var>{{=it.LEVELUP_MP_PLUS_MIN}} ~ {{=it.LEVELUP_MP_PLUS_MAX}}</var></li>
            <li class="MP_RECOVER_TIC"><label>MP 회복(틱)</label><var>{{=it.MP_RECOVER_TIC}}</var></li>
            <li class="MP_RECOVER_LIQUOR"><label>MP 물약 회복(틱)</label><var>{{=it.MP_RECOVER_LIQUOR}}</var></li>
            <li class="MR"><label>마법 방어력(MR)</label><var>{{=it.MR}}</var></li>
					</ul>
				</dd>
			</dl>

			<dl class="stat-CON">
				<dt class="CON">
					<strong>CON</strong>
					<span class="util">
						{{? it.page === "default" || it.page === 'modify' }}<button class="down">-</button>{{?}}
						<var>{{=it.CON}}</var>
						{{? it.page === "default" || it.page === 'modify' }}<button class="up">+</button>{{?}}
					</span>
				</dt>
				<dd>
					<ul>
						<li class="HP_PLUS"><label>레벨업시 HP 증가</label><var>{{=it.LEVELUP_HP_PLUS_MIN}} ~ {{=it.LEVELUP_HP_PLUS_MAX}}</var></li>
            <li class="HP_RECOVER_TIC"><label>HP 회복(틱)</label><var>{{=it.HP_RECOVER_TIC_MIN}} ~ {{=it.HP_RECOVER_TIC_MAX}}</var></li>
            <li class="HP_RECOVER_LIQUOR"><label>HP 물약 회복 증가</label><var>{{=it.HP_RECOVER_LIQUOR}}</var></li>
            <li class="WEIGHT"><label>최대 소지 무게</label><var>{{=it.WEIGHT}}</var></li>
					</ul>
				</dd>
			</dl>

			<dl class="stat-CHA">
				<dt class="CHA">
					<strong>CHA</strong>
					<span class="util">
						{{? it.page === "default" || it.page === 'modify' }}<button class="down">-</button>{{?}}
						<var>{{=it.CHA}}</var>
						{{? it.page === "default" || it.page === 'modify' }}<button class="up">+</button>{{?}}
					</span>
				</dt>
				<dd>
                  <ul>
                    <li class="CHA_HIT_SIKII"><label>기술 적중</label><var>{{=it.CHA_HIT_SIKII}}</var></li>
                    <li class="CHA_HIT_SUMMON"><label>정령 적중</label><var>{{=it.CHA_HIT_SUMMON}}</var></li>
                    <li class="CHA_HIT_DRAGON"><label>용언 적중</label><var>{{=it.CHA_HIT_DRAGON}}</var></li>
                    <li class="CHA_HIT_FEAR"><label>공포 적중</label><var>{{=it.CHA_HIT_FEAR}}</var></li>
                    <li class="CHA_SKILL_TIME_REDUCTION"><label>스킬 쿨타임 감소</label><var>{{=it.CHA_SKILL_TIME_REDUCTION}}</var></li>
                    <li class="CHA_STATUS_TIME_REDUCTION"><label>상태 이상 시간 감소</label><var>{{=it.CHA_STATUS_TIME_REDUCTION}}</var></li>
                  </ul>
                </dd>
			</dl>
	  </section>`;
};

export const getStatSimulatorTpl = () => { // 2022.01. 레벨 추가
  return `<section class="simulator__stat" tabindex="0">
    <header>
      <span class="icon-back" title="뒤로"></span>
      <h3></h3>
        <div class="util">
          {{? it.page === "default" || it.page === 'modify' }}
            <button class="btn-save">저장</button>
            <button class="btn-reset">초기화</button>

          {{?? it.page === "view" }}
            <button class="btn-modify">수정</button>
            <button class="btn-delete">삭제</button>
          {{?}}
        </div>
    </header>

    <section class="char char__stat">
      <div class="base">
        <img src="{{=it.classImageUrl}}" class="thumb" />
        <span class="name"></span>
        <span class="server"></span>
        <span class="level"><strong>{{=it.level}}</strong>Lv.</span>
        <span class="level_target"><strong>{{=it.targetLevel}}</strong>Lv.</span>
      </div>

      {{? it.page === "default" || it.page === 'modify' }}
      <div class="wrap-button">
        <button class="button btn-levelup">레벨 UP</button>
        <div class="tooltip-levelup"></div>
      </div>

      <div class="point">
        <p><label>남은 스탯</label><var><strong class="em">{{=it.remainStat}}</strong><span class="total">({{=it.remainTotalStat}})</span></var></p>
        <p class="elixir"><span class="custom-checkbox"><input type="checkbox" name="ELIXIR_POINT" id="ELIXIR_POINT" value=""></span><label for="ELIXIR_POINT">엘릭서 스탯</label><var><strong>{{=it.elixirStat}}</strong><span class="total">({{=it.elixirTotalStat}})</span></var></p>
      </div>
      {{?}}

      <div class="hpmp">
        <ul>
          <li class="hp">
            <label>HP</label>
            <span class="graph"><figure style="width:100%"></figure></span>
            <var>{{=it.HP}}</var>
          </li>

          <li class="mp">
            <label>MP</label>
            <span class="graph"><figure style="width:100%"></figure></span>
            <var>{{=it.MP}}</var>
          </li>
        </ul>
      </div>
    </section>

    ${getSectionTpl()}

    {{? it.page === "default" || it.page === 'modify' }}
    <footer>
      <p>PC에서는 키보드의 [V]버튼으로 간편하게 레벨업 할 수 있습니다.</p>
    </footer>
    {{?}}
  </section>`;
};

export const getStatStorageItemTpl = (hasDeleteBtn = false) => {
  const deleteBtnTpl = (hasDeleteBtn === true) ? '<button class="btn-delete" title="delete"></button>' : '';

  return `<article class="storage__stat" data-idx="{{=it.idx}}" data-class-id="{{=it.classId}}" data-level="{{=it.level}}" data-hp="{{=it.hp}}" data-mp="{{=it.mp}}" >
    <div class="char">
      <img src="{{=it.classImageUrl}}" class="thumb">
      <span class="name"></span>
      <span class="server"></span>
      <span class="level">{{=it.level}}Lv.</span>
      <span class="date">{{=it.date}}</span>
    </div>

    <div class="stat">
      <ul>
        <li class="stat-STR">
          <label>STR</label>
          <span class="graph"><figure style="width:{{=it.percentageSTR}}"></figure></span>
          <var>{{=it.statMetaInfo.mainStat.STR}}</var>
        </li>
        <li class="stat-DEX">
          <label>DEX</label>
          <span class="graph"><figure style="width:{{=it.percentageDEX}}"></figure></span>
          <var>{{=it.statMetaInfo.mainStat.DEX}}</var>
        </li>
        <li class="stat-INT">
          <label>INT</label>
          <span class="graph"><figure style="width:{{=it.percentageINT}}"></figure></span>
          <var>{{=it.statMetaInfo.mainStat.INT}}</var>
        </li>
        <li class="stat-WIS">
          <label>WIS</label>
          <span class="graph"><figure style="width:{{=it.percentageWIS}}"></figure></span>
          <var>{{=it.statMetaInfo.mainStat.WIS}}</var>
        </li>
        <li class="stat-CON">
          <label>CON</label>
          <span class="graph"><figure style="width:{{=it.percentageCON}}"></figure></span>
          <var>{{=it.statMetaInfo.mainStat.CON}}</var>
        </li>
        <li class="stat-CHA">
          <label>CHA</label>
          <span class="graph"><figure style="width:{{=it.percentageCHA}}"></figure></span>
          <var>{{=it.statMetaInfo.mainStat.CHA}}</var>
        </li>
      </ul>
    </div>

    ${deleteBtnTpl}
  </article>`
};


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/model/tpl/stat.js